
document.querySelectorAll('.middle_menu li ').forEach((listElement) => {
	listElement.addEventListener('mouseenter', function(event){
		// console.log('list element hovered');
	});
	listElement.querySelectorAll('[id^="Details-"]').forEach((details) => {
		details.addEventListener('mouseenter', function(event){
			details.setAttribute('open', true);
		});
		details.querySelector('.background_submenu_holder').addEventListener('mouseleave', function(event){
			details.removeAttribute('open', false);
		});
	})

	listElement.addEventListener('mouseleave', function(event){
		childs = listElement.parentNode.childNodes;
		childs.forEach((kidElement)=>{
			//check if text node
			if(kidElement.nodeType!=3){
				kidElement.querySelectorAll('[id^="Details-"]').forEach((details)=>{
					details.removeAttribute('open', false);
				})
			}
		})
	});
});
